import React, { memo, useEffect } from "react";
import ReactDOM from "react-dom";
import { v4 as uuid } from "uuid";

const modalRoot = document.getElementById("portal");

function ModalPopup(props) {
   const { id, className = "", isReferralView = false.valueOf, withdrawAction = true, alter = false } = props;
   const modalId = id ? id : uuid();
   const screenWidth = window.screen.width;
   useEffect(() => {
      let body = document.getElementById("div-scroll-top");
      if (screenWidth < 800) {
         body.style.overflowY = "hidden";
      }
      if (withdrawAction) {
         window.addEventListener("keypress", onKeyPress);
      }
      return () => {
         if (withdrawAction) {
            window.removeEventListener("keypress", onKeyPress);
         }
         let popup = document.getElementsByClassName("ModalPopup");
         if (popup.length > 0) return;
         body.style.overflowY = "scroll";
      };
   }, []);

   const onKeyPress = (e) => {
      if (e.key === "Enter") {
         document.getElementById("enter-action-button") && document.getElementById("enter-action-button").click();
      }
   };
   return ReactDOM.createPortal(
      <div
         id={modalId}
         style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            zIndex: 99,
            overflow: "hidden",
            backgroundColor: "rgba(79, 79, 79, 0.31)",
            ...props.styles,
            overflowY: isReferralView && "auto",
         }}
         className={`ModalPopup ${!alter && "flex items-center justify-center"} ${className}`}
         onMouseDown={(e) => {
            if (e.target.classList.contains("ModalPopup")) {
               e.stopPropagation();
               props.onModalTapped && props.onModalTapped();
            }
         }}
      >
         {props.children}
      </div>,
      modalRoot
   );
}
export default memo(ModalPopup);
